import { useMemo } from 'react';
import { useOnboardingResources } from '../resourcesQueries';
const DEFAULT_PAGE_LENGTH = 12;
const isNotStarted = resource => {
  var _resource$progress;
  return ((_resource$progress = resource.progress) === null || _resource$progress === void 0 ? void 0 : _resource$progress.status) === 'NOT_STARTED';
};
export const useEligibleOnboardingResources = ({
  pageLength = DEFAULT_PAGE_LENGTH,
  skip = false
} = {}) => {
  const {
    resources,
    loading,
    error
  } = useOnboardingResources({
    contentTypes: ['LEARNING_PATH', 'SHORT_FORM_CONTENT'],
    pageLength,
    skip
  });
  const {
    playlists,
    recordings
  } = useMemo(() => {
    const eligible = (resources !== null && resources !== void 0 ? resources : []).filter(isNotStarted);
    return {
      playlists: eligible.filter(resource => resource.type === 'LEARNING_PATH'),
      recordings: eligible.filter(resource => resource.type === 'SHORT_FORM_CONTENT')
    };
  }, [resources]);
  return {
    playlists,
    recordings,
    loading,
    error
  };
};